/**
 * Normalizes a human display string into a URL/data-safe slug for matching
 * against the family asset map's slug keys.
 *
 * Lowercases, strips parenthetical qualifiers (e.g. "Oak (Natural)" -> "oak"),
 * collapses any run of non-alphanumerics to a single dash, and trims leading/
 * trailing dashes.
 *
 * @example
 * slugify('Brushed Nickel')      // 'brushed-nickel'
 * slugify('Oak (Natural)')       // 'oak'
 * slugify('  Nailhead / Finish') // 'nailhead-finish'
 */
export function slugify(value: string): string {
	return value
		.toLowerCase()
		.trim()
		.replace(/\([^)]*\)/g, '')
		.trim()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-|-$/g, '');
}
